import { CompanyDetails } from '@/models/company-details'

export class Company{
  id?: string;
  name?: string;
  code?: string;
  zipCode?: string;
  address?: string;
  facilityName?: string;
  details?: CompanyDetails;

  constructor(params?: Partial<Company>) {
    Object.assign(this, params);
  }
}